import React from "react";

import { CancelJobDetails } from "@api/job/cancelJob";
import { Card, Typography, Avatar, Chip, Box, Link, useTheme } from "@mui/material";
import dayjs from "dayjs";

import { withCancelRequestHint } from "@utils/withCancelRequestHint";

import RequestDetailsDialog from "./CancelRequestDetails";
import { CancelRequestStatus } from "./type";

// Define types for props

// Reusable Card Component
const CancelRequestCard: React.FC<CancelJobDetails> = ({
  user,
  status,
  createdAt,
  reason,
  jobId,
}) => {
  const {
    palette: { common },
  } = useTheme();
  const requestDetail = {
    requestor: {
      name: user.name,
      avatar: user.avatar,
      id: user.id,
    },
    status: status as CancelRequestStatus,
    timeRequested: createdAt,
    reason,
  };
  const [openDetails, setOpenDetails] = React.useState(false);

  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "center",
        p: 2,
        minWidth: 250,
        borderRadius: 2,
        boxShadow: 1,
        flexShrink: 0,
      }}
    >
      <Avatar src={user.avatar} alt={user.name} sx={{ width: 40, height: 40, mr: 2 }} />
      <Box>
        <Typography fontSize={12}>
          <strong>{user.name}</strong> submitted a{" "}
          <Link
            underline="hover"
            color={common.mediumText}
            sx={{
              cursor: "pointer",
            }}
            onClick={() => setOpenDetails(true)}
          >
            Cancel Request
          </Link>
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            fontSize: 12,
            mt: 0.5,
            justifyContent: "space-between",
          }}
        >
          <Box display={"flex"} alignItems={"center"} gap={1}>
            <Chip
              label={status}
              sx={{
                textTransform: "capitalize",
                color:
                  status === CancelRequestStatus.Pending
                    ? common.mediumText
                    : common.black,
                bgcolor:
                  status === CancelRequestStatus.Pending
                    ? common.mediumPriorty
                    : common.bellflowerBlue,
              }}
              size="small"
            />
            {status === CancelRequestStatus.Pending &&
              withCancelRequestHint({
                when: createdAt,
              })}
          </Box>
          <Typography variant="caption" sx={{ ml: 1, color: "text.secondary" }}>
            {dayjs(createdAt).fromNow()}
          </Typography>
        </Box>
      </Box>
      <RequestDetailsDialog
        open={openDetails}
        onClose={() => setOpenDetails(false)}
        requestDetails={requestDetail}
        jobId={jobId}
      />
    </Card>
  );
};

export default CancelRequestCard;
